<div #pageHeader>
  <fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false" [showFooter]="false" [backButtonLink]="'/'" />
  <div class="container bg-primary member-card-container">
    <fgb-member-card [wallet]="true"></fgb-member-card>
  </div>
</div>
<div #walletContainer class="mobile-content-wrapper">
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="grab-point"><span class="minimize-icon"> </span></div>
  </ng-container>
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel">
      <div class="container">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <div class="container mt-3 text-center mb-5">
    <div class="claimed-button border border-secondary">
      <div class="claimed-button-text">
        <h5 class="mb-1">{{ 'wallet.claimed.rewards' | translate }}</h5>
        <div class="font-praktika-normal font-size-14">{{ 'wallet.claimed.rewards.history' | translate }}</div>
      </div>
      <a
        class="font-praktika-bold font-size-14 claimed-text fw-bold btn btn-secondary border-secondary rounded text-white"
        [routerLink]="['/rewards/claimed']"
      >
        {{ 'view.claimed.rewards' | translate }}
      </a>
    </div>
  </div>
</div>
